import { DEFAULT_RANGE } from "../components/rangeSlider/lib/constant";
import { EMPTY_YEAR } from "../../../../../shared/typeahead-prefill";

export const DEFAULT_LIGHTING_PANEL = {
    modelNumber: "",
    brightness: [],
    estimatedYearlyCost: [],
    estimatedYearlyCostDisclaimer: "",
    lifeExpectancy: EMPTY_YEAR,
    lifeExpectancyDisclaimer: "",
    ranges: [{ ...DEFAULT_RANGE }],
    energyUsed: [],
    baseSize: "",
    bulbQuantity: "",
    legalTerms: "",
    additionalProductDetails: "",
    isThreeWay: false,
    isDimmable: false,
    isFloodLight: false,
    isCeilingFanCompatible: false,
    isEcoFriendly: false,
    containsMercury: false,
    hasEnergyStarLogo: false,
    hasEnergySmartLogo: false,
    FTCMercuryWarning: "For more on clean up and safe disposal, visit epa.gov/cfl.",
};

export const PACKAGE_SIZES = [
    { value: "2-Pack", text: "2-Pack" },
    { value: "4-Pack", text: "4-Pack" },
    { value: "6-Pack", text: "6-Pack" },
    { value: "8-Pack", text: "8-Pack" },
    { value: "10-Pack", text: "10-Pack" },
    { value: "12-Pack", text: "12-Pack" },
];

export const BULB_TYPES = [
    { value: "CFL", text: "CFL" },
    { value: "Fluorescent", text: "Fluorescent" },
    { value: "Halogen", text: "Halogen" },
    { value: "HID", text: "HID" },
    { value: "Incandescent", text: "Incandescent" },
    { value: "LED", text: "LED" },
];

export const BULB_COLORS = [
    { value: "Black", text: "Black" },
    { value: "Blue", text: "Blue" },
    { value: "Clear", text: "Clear" },
    { value: "Color Changing", text: "Color Changing" },
    { value: "Frosted", text: "Frosted" },
    { value: "Glass", text: "Glass" },
    { value: "Green", text: "Green" },
    { value: "Multi-Color", text: "Multi-Color" },
    { value: "Orange", text: "Orange" },
    { value: "Pink", text: "Pink" },
    { value: "Purple", text: "Purple" },
    { value: "Red", text: "Red" },
    { value: "Stained", text: "Stained" },
    { value: "Yellow", text: "Yellow" },
];

export const INDOOR_OUTDOOR = [
    { value: "Indoor", text: "Indoor" },
    { value: "Outdoor", text: "Outdoor" },
    { value: "Both", text: "Both" },
];

export const BULB_BASES = [
    { value: "Bayonet", text: "Bayonet" },
    { value: "Pin", text: "Pin" },
    { value: "Screw", text: "Screw" },
];
